<template>
  <v-row justify="center">
    <v-dialog v-model="isOpen" persistent max-width="700">
      <v-card class="pa-card-custom">
        <v-card-title class="title justify-center">
          <h3>Add Your {{ title_dialog }} ID</h3>
          <span class="body-2 pt-4 font-weight-regular text-center"
            >Paste your {{ title_dialog }} container ID below to update your site tags and
            code.</span
          >
        </v-card-title>
        <v-card-text class="pa-4">
          <v-text-field
            type="text"
            outlined
            solo
            dense
            flat
            placeholder="e.g., GTM-XXXXXX"
            hide-details="auto"
            class="py-5"
            v-model="enterCodeOrId"
            clearable
          ></v-text-field>
          <warnningComponent
            v-bind:textInfo.sync="textWarning"
            v-bind:typestatus.sync="typeWarning"
            v-bind:alert.sync="showWarnnig"
          ></warnningComponent>
        </v-card-text>
        <!-- <v-card-actions class="d-flex flex-column"> -->
        <v-card-actions>
          <v-btn text x-small color="primary" @click="instruction_dialog = true">
            Instructions to connect
          </v-btn>
          <v-spacer />
          <v-btn
            class="text-capitalize ma-1"
            outlined
            width="100"
            depressed
            color="primary"
            @click="checkCloseDialog()"
          >
            Close
          </v-btn>
          <v-btn
            class="text-capitalize ma-1"
            width="100"
            depressed
            color="primary"
            :disabled="!enterCodeOrId"
            @click="saveIdOrCodeTools()"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="checkclose_dialog" persistent max-width="450">
      <v-card>
        <v-card-title class="headline"><p>พบการแก้ไขข้อมูล</p></v-card-title>
        <v-card-text>
          <p>คุณไม่ได้บันทึกการแก้ไข ต้องการกลับไปแก้ไขต่อหรือไม่</p>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            elevation="0"
            class="px-9 ma-2 subtitle-2 button-secondary font-weight-light text-capitalize"
            outlined
            @click="checkclose_dialog = false"
            >แก้ไขต่อ</v-btn
          >
          <v-btn
            class="px-10 ma-2 subtitle-2 text-capitalize font-weight-light button-primary"
            @click="
              checkclose_dialog = false;
              closeConnectDialog();
            "
            >ออกจากหน้านี้</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="instruction_dialog" persistent max-width="1200px">
      <v-card class="pa-5">
        <v-card-title>
          <v-row>
            <div style="margin-right: 20px">
              <v-img
                max-height="30.5px"
                max-width="30.5px"
                src="@/assets/marketing-tools/icon-googleTag.png"
              ></v-img>
            </div>
            <div>
              <v-row>
                <span class="title font-weight-regular grey--text text--darken-2">{{
                  title_dialog
                }}</span>
              </v-row>
              <v-row>
                <span class="body-1"
                  >Use these tools to make your marketing more effective.</span
                >
              </v-row>
            </div>
          </v-row>
        </v-card-title>
        <v-card class="card-content-instruction" min-height="600px">
          <v-card-title class="pl-0">
            <h3 class="font-weight-regular grey--text text--darken-2">
              Connecting Google Analytics to Your Website.
            </h3>
            <span class="body-2">
              Google Analytics allows you to track information including the number of
              visitors and page views, where visitors come from, how long they stay, what
              keywords they are using to find your site, and more.
            </span>
          </v-card-title>
          <v-alert color="warning" border="left" colored-border>
            <span class="body-2"
              ><b>Important:</b><br />
              Google Analytics has upgraded to version 4 (GA4). This change introduced a
              new measurement ID in the format G-XXXXXXXXXX. The new format is not
              currently supported by Wix, but we are working to make this feature
              available in the near future. In the meantime, you can follow the
              instructions below to integrate Google Analytics using a Universal Analytics
              code.
            </span>
          </v-alert>
        </v-card>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            class="text-capitalize ma-1"
            outlined
            width="100"
            depressed
            color="primary"
            @click="instruction_dialog = false"
          >
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>
<script>
import { updateConnectTool } from "@/service/company/company";
import warnningComponent from "../../../components/warningAlert.vue";

export default {
  components: {
    warnningComponent,
  },
  props: {
    isOpen: {
      type: Boolean,
    },
    connectTools: {
      type: Object,
    },
    title_dialog: {
      type: String,
    },
    closeConnectDialog: {
      type: Function,
    },
  },
  data() {
    return {
      instruction_dialog: false,
      enterCodeOrId: "",

      //warrning
      textWarning: "",
      typeWarning: "",
      showWarnnig: false,

      oldId: "",
      newId: "",
      checkclose_dialog: false,
    };
  },
  watch: {
    connectTools() {
      this.initialize();
    },
  },
  methods: {
    initialize() {
      this.oldId = this.connectTools.googleTagManager;
      this.enterCodeOrId = this.oldId;
    },
    async saveIdOrCodeTools() {
      this.newId = this.enterCodeOrId;
      if (this.enterCodeOrId && this.oldId != this.newId) {
        let resultUpdateTool = await updateConnectTool({
          connectToolsWith: {
            ...this.connectTools,
            googleTagManager: this.enterCodeOrId,
          },
        });
        if (resultUpdateTool.code == 403 || resultUpdateTool.code == 404) {
          this.warnnig("บันทึกข้อมูลไม่สำเร็จ", "warning");
        } else {
          this.closeConnectDialog();
        }
      } else {
        this.closeConnectDialog();
      }
    },
    checkCloseDialog() {
      this.newId = this.enterCodeOrId;
      if (this.oldId != this.newId) {
        this.checkclose_dialog = true;
      } else {
        this.checkclose_dialog = false;
        this.closeConnectDialog();
      }
    },
    warnnig(text, type) {
      this.textWarning = text;
      this.typeWarning = type;
      this.showWarnnig = true;
      setInterval(() => {
        this.showWarnnig = false;
      }, 5000);
    },
  },
};
</script>
<style scoped>
.pa-card-custom {
  padding: 30px !important;
}
.card-content-instruction {
  border-radius: 5px;
  padding: 30px;
  padding-top: 10px;
  overflow-y: scroll;
}
</style>
